import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const TelegramWidget = ({ html }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return undefined;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    const script = tempDiv.querySelector('script');
    if (script) {
      const scriptClone = document.createElement('script');

      Array.from(script.attributes).forEach(attr => {
        scriptClone.setAttribute(attr.name, attr.value);
      });

      containerRef.current.appendChild(scriptClone);
    }

    const container = containerRef.current;

    return () => {
      container.innerHTML = '';
    };
  }, []); // eslint-disable-line

  return <div ref={containerRef} />;
};

TelegramWidget.propTypes = {
  html: PropTypes.string.isRequired,
};

export default TelegramWidget;
